import type { NotificationDto } from "@ied/shared-types";
import { useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useGetNotification(id?: string) {
	return useQuery({
		enabled: !!id,
		queryKey: ["notifications", id],
		queryFn: async () => {
			const res = await fetch(`${SERVICE_API}/api/notifications/${id}`, {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to fetch notification details");
			}

			return (await res.json()) as NotificationDto;
		},
	});
}
